<script>
import './style.scss';
import template from './template.html';
import { Editor, EditorContent } from '@tiptap/vue-2';
import Toolbar from './Toolbar.vue';
import StarterKit from '@tiptap/starter-kit';
import Text from '@tiptap/extension-text';
import TextStyle from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import Link from '@tiptap/extension-link'
import CharacterCount from '@tiptap/extension-character-count'
import {CustomImageExtension} from './custom-image-extension'
import CustomImage from './custom-image-node';
import ImageUploadExtension from './image-extension';

export default {
  
  template,
  
  components: {
    EditorContent,
    Toolbar
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    
    charLimit: {
      type: Number,
      default: 349525
    },

    isEditable: {
      type: Boolean,
      default: true
    },

    orderId: {
      type: [String, Number],
      default: 0 
    },
    
    /*
    //options for adding image and resizing
    onImage: {
      type: Function
    },
    
    resizeMaxWidth: {
      type: Number,
      default: 600
    },
    
    resizeMaxHeight: {
      type: Number,
      default: 400
    }
    */
  },
  
  computed: {},
  
  methods: {
    
    onDrop (evt) {
      console.log('the event', evt)
      console.log('data transfer', evt.dataTransfer)
      
      var imageUrl = evt.dataTransfer.getData('text/html');
    console.log('imageurl', imageUrl)
    },
    
    onPaste (evt) {
      console.log('evt paste', evt)
    },
    
    onToolbarCommand (packet) {
      let {action, params} = packet;
      let command = this.editor.commands[action];
      
      params = params || [];
      
      if (action == 'setLink') {
        return this.setLink(...params);
      }
    
      command(...params);
      
      this.notifyActiveWidgets()
    },
    
    notifyActiveWidgets () {
      //if (!this.editor.isActive()) return;
      
      let activeTools = [];
      let editor = this.editor;
      let { nodes, marks } = editor.schema;
      
      let nodeList = [
        ...(Object.keys(nodes)),
        ...(Object.keys(marks))
      ];
      
      nodeList.forEach(nodeName => {
        if(this.editor.isActive(nodeName)) {
          activeTools.push(nodeName);
        }
      })
      
      this.activeTools = activeTools;
    },
    
    setLink() {
      const editor = this.editor;
      const currentSelectionIsEmpty = editor.view.state.selection.empty
      const previousUrl = editor.getAttributes('link').href
      let url = window.prompt('URL', previousUrl)
      const originalUrl = url;

      const unsetLink = () => {
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .unsetLink()
          .run()
      }

      // cancelled
      if (url === null) {
        return
      }

      // empty
      if (url === '') {
        unsetLink();
        return
      }

      //make sure the link is a valid url format
      try {
        url = this.ensureProtocol(url);
      } catch (e) {
        url = '';
        unsetLink();
        return console.error('could not set link', url);
      }

      //check if teh user has selected any text to set a link to
      //if selection is empty than make the link the text
      if (currentSelectionIsEmpty) {

        //insert the users typed url as text into the editor
        //set the cursor to end of text
        editor.chain()
          .focus()
          .insertContent(originalUrl)
          .selectTextblockEnd()
          .run();

        //wait, then select the inserted text
        //and add the formatted link
        setTimeout(() => {
          let currentCursorPos = editor.view.state.selection.anchor;

          editor
            .chain()
            .focus()
            .setTextSelection({from: currentCursorPos - originalUrl.length, to: currentCursorPos })
            .setLink({href: url})
            .run();
        },30)
      } else {
        // update link
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: url })
          .run()
        }
    },

    ensureProtocol (url, defaultProtocol = 'https') {
      try {
        const parsedUrl = new URL(url);

        return parsedUrl.href;
      } catch (error) {
        const parsedUrlWithProtocol = new URL(`${defaultProtocol}://${url}`);
        return parsedUrlWithProtocol.href;
      }
    },
  },

  data() {
    return {
      editor: {},
      activeTools: [],
      ready: false
    }
  },

  watch: {
    
    value(value) {
      const isSame = this.editor.getHTML() === value

      if (isSame) return

      this.editor.commands.setContent(value, false)
    },
  },
  
  mounted () {
    this.ready = true;
  },

  beforeMount() {
    const $vm = this;
    
    this.editor = new Editor({
      onSelectionUpdate({ editor }) {
        // The selection has changed.
        $vm.notifyActiveWidgets()
      },
      extensions: [
        StarterKit,
        Text,
        TextStyle,
        BulletList,
        Color.configure({
          types: ['textStyle'],
        }),
        ListItem.configure({
          // HTMLAttributes: {
          //   class: 'my-custom-class',
          // },
        }),
        Link.configure({
          // HTMLAttributes: {
          //   class: 'my-custom-class',
          // },
          openOnClick: true,
          linkOnPaste: true,
        }),
        CharacterCount.configure({
          //mode: 'nodeSize',
          limit: this.charLimit,
        }),

        CustomImage.configure({
          resizeMaxWidth: 600,
          resizeMaxHeight: 300,
          uploadUrl: '/files/upload',
          orderId: this.orderId
        }),
        
        /*CustomImageExtension.configure({
          inline: true,
          
          //reader must return a promise
          //that outputs a base64 string
          //default uses browser reader function
          //imageReader: (file) => {},
          
          //imageUpload: (imgFile) => {},
          
          //resizeMaxWidth: 600,
          //resizeMaxHeight: 300,
          
          HTMLAttributes: {
            //class: 'my-custom-class',
            //style: 'display:block;max-width:100%'
          },
        }),*/
      ],
      content: this.value,
      onUpdate: () => this.$emit('input', this.editor.getHTML()),
      editable: this.isEditable,
    })
  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>
